import { RotateCcwIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { BasicNumberEditorField } from '@/entities/column'

import {
	InputGroup,
	InputGroupAddon,
	InputGroupButton,
	InputGroupInput,
} from '@/shared/components/ui/input-group'
import { cn } from '@/shared/lib/utils'

import { generateFamilyId } from '../lib/helpers'

export const SourceFamilyIdCell = () => {
	const { watch, setValue } = useFormContext()
	const sourceFamilyId = watch('source_family_id') as string

	return (
		<InputGroup>
			<InputGroupInput
				value={sourceFamilyId}
				onChange={(e) => setValue('source_family_id', e.target.value)}
			/>
			<InputGroupAddon align='inline-end'>
				<InputGroupButton
					size='icon-xs'
					onClick={() => setValue('source_family_id', generateFamilyId())}
				>
					<RotateCcwIcon />
				</InputGroupButton>
			</InputGroupAddon>
		</InputGroup>
	)
}

export const MulIdxCell = () => {
	const {
		watch,
		setValue,
		clearErrors,
		formState: { errors },
	} = useFormContext()
	const value = watch('mul') as number

	return (
		<BasicNumberEditorField
			className={cn(
				'rounded-lg border bg-input/20 px-3 py-1 dark:bg-input/30',
				{
					'border-destructive ring-[3px] ring-destructive/20 dark:ring-destructive/40':
						errors?.mul,
				}
			)}
			value={value}
			onChange={(value) => {
				setValue('mul', value, {
					shouldValidate: true,
				})
				clearErrors(['add', 'mul'])
			}}
			originalValue={null}
			isDirty={!!value}
		/>
	)
}

export const AddIdxCell = () => {
	const {
		watch,
		setValue,
		formState: { errors },
	} = useFormContext()
	const value = watch('add') as number

	return (
		<BasicNumberEditorField
			className={cn(
				'rounded-lg border bg-input/20 px-3 py-1 dark:bg-input/30',
				{
					'border-destructive ring-[3px] ring-destructive/20 dark:ring-destructive/40':
						errors?.add,
				}
			)}
			value={value}
			onChange={(value) =>
				setValue('add', value, {
					shouldValidate: true,
				})
			}
			originalValue={null}
			isDirty={!!value}
		/>
	)
}
